import { RouteComponentProps } from "../../../../models/RouteComponent";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { ToolboxTalkRecord } from "../../../../models/DSF/ToolboxTalks";
import useApiService from "../../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../../../../utils/DateUtils";
import { Dialog } from "primereact/dialog";

function ToolboxTalks(props: RouteComponentProps) {
  const { session } = props;

  const [selectedRecord, setSelectedRecord] = useState<ToolboxTalkRecord | null>(null);
  const { data, loading, error } = useApiService<ToolboxTalkRecord[]>({
    method: "GET",
    url: "site-toolbox-talk",
    params: {
      clientId: session.client_id,
      siteId: session.site_id,
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  const displayCreatedAt = (data: ToolboxTalkRecord) => {
    return <>{formatDate(data.created_at)}</>;
  };

  const displayUpdatedAt = (data: ToolboxTalkRecord) => {
    return <>{formatDate(data.updated_at)}</>;
  };

  return (
    <>
      <Typography level="h2" component="h1">
        Toolbox talks
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
      {error && (
        <div className={"error-wrapper"}>
          <p>Could not load toolbox talks</p>
        </div>
      )}
      {data && (
        <DataTable
          value={data}
          onRowClick={e => {
            setSelectedRecord(e.data as ToolboxTalkRecord);
          }}
          className={"policies-procedures-table"}
        >
          <Column field={"topic"} header={"Topic"} />
          <Column field={"created_at"} header={"Created at"} body={displayCreatedAt} />
          <Column field={"updated_at"} header={"Updated at"} body={displayUpdatedAt} />
        </DataTable>
      )}
      {selectedRecord && (
        <Dialog
          onHide={() => setSelectedRecord(null)}
          visible={!!selectedRecord}
          header={selectedRecord.topic}
          style={{ width: "60vw" }}
        >
          <div dangerouslySetInnerHTML={{ __html: selectedRecord.body || "" }} />
        </Dialog>
      )}
    </>
  );
}

export default ToolboxTalks;
